import { render, staticRenderFns } from "./HeaderAssistantQuestion.vue?vue&type=template&id=52a9fcf8&scoped=true"
import script from "./HeaderAssistantQuestion.vue?vue&type=script&lang=js"
export * from "./HeaderAssistantQuestion.vue?vue&type=script&lang=js"
import style0 from "./HeaderAssistantQuestion.vue?vue&type=style&index=0&id=52a9fcf8&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52a9fcf8",
  null
  
)

export default component.exports